var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.sources),function(source,source_i){return (_vm.sources)?_c('sup',{key:source_i,staticClass:"cursor-pointer text-xs pl-2 pr-2 mini-source",staticStyle:{"text-decoration":"underline","padding":"0 3px"},on:{"click":function($event){$event.preventDefault();return _vm.gotoSource(source)}}},[_vm._v(_vm._s(source.source_id))]):_vm._e()}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2de76c92","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/covid19/MiniSourceLink.vue
// module id = 472
// module chunks = 0